module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/clients/client-detail/client-detail-users/client-detail-users.component.scss
// module id = ./src/app/clients/client-detail/client-detail-users/client-detail-users.component.scss
// module chunks = main